import { Action } from "../../shell/Actions/Action";
import Character from "../../shell/Character";
import Game from "../../shell/Game";
import { setAdvance, setSeenImage } from "../../store/slices/AdvanceSlice";
import { setLastUpdated, TCharacter, TimageINT, TquestionFormat, TquestionINT, TtalkStateINT, TtalkStateINTOptions } from "../../store/slices/gameObjectSlice";
import { GameNames } from "../../store/slices/GameTypes";
import { ContactsUI, PhoneTypes, setHistory, setPhone, setPhoneButtons, setPhoneComment, setPhoneDisplay, showMessagesUI, TPhoneContact, TPhoneINT, setPhoneImage, setPhoneMessage, setPhoneQuestion, PhoneQuestionFormat } from "../../store/slices/phoneSlice";
import { store } from "../../store/store";

interface TPhone {
    image: TimageINT,
    comment?: string;
}
export enum PHONE_BUTTONS {
    RIGHT = 'RIGHT',
    LEFT = 'LEFT',
    EXIT = 'EXIT',
    THUMBS_UP = 'THUMBS_UP',
    THUMBS_DOWN = 'THUMBS_DOWN'
}

export interface PhoneINT {
    main: TPhone,
    left: TPhone[],
    right: TPhone[],

}
export class Phone {
    static finishedHistory = false;

    static phonePromise: ((value: unknown) => void) | undefined | undefined | null;

    static open(image: Partial<TimageINT> | undefined, func: Function, options?: Partial<TPhoneINT>): Promise<PHONE_BUTTONS> {
        // const _data = <TPhoneINT>{ images };
        const _data = <TPhoneINT>{ image };

        return new Action(image, GameNames.PHONE).run(
            function phone(callback: () => void) {
                store.dispatch(setPhone(_data));
                if (image) {
                    store.dispatch(setSeenImage(image as TimageINT));
                }
                Phone.phonePromise = Game.Action?.promise;
                func();
                if (!Game.rollback) {
                    store.dispatch(setLastUpdated({ updatedValue: GameNames.PHONE, clear: true }));
                    store.dispatch(setPhoneDisplay({ display: true, displayMessagesUI: false, ...options }));

                }
            }
            , false);
    }
    static talk(data: TtalkStateINT): Promise<any> {
        return new Action({ ...data }, GameNames.PHONE).run(
            function phone(callback: () => void) {
                store.dispatch(setPhoneComment(data));

            }
        );
    }
    static onBtnPressed(promiseRes: PHONE_BUTTONS) {
        Phone.phonePromise?.(promiseRes);
        store.dispatch(setAdvance({ canAdvance: true }));
    }
    static close(promiseRes: any) {
        Game.Action?.promise(promiseRes);
        store.dispatch(setPhoneDisplay({ display: false, displayMessagesUI: false }));
    }
    static setButtons(buttons: PHONE_BUTTONS[]) {

        store.dispatch(setPhoneButtons(buttons));
    }
    static showMessagesUI(contact: TPhoneContact, func: Function) {
        const profilePic = contact.profileImage || Character.characters.find(c => c.name === contact.name)?.properties?.instaProfileImage;
        const _data: ContactsUI = { selectedContact: { ...contact, profileImage: profilePic } };
        return new Action(_data, GameNames.PHONE).run(
            function phone(callback: () => void) {
                Phone.phonePromise = Game.Action?.promise;
                store.dispatch(showMessagesUI(_data));
                store.dispatch(setLastUpdated({ updatedValue: GameNames.PHONE, clear: true }));
                store.dispatch(setPhoneDisplay({ display: false, displayMessagesUI: true }));
                func();
            }
            , false);
    }
    static closeMessagesUI() {
        const _data = <TPhoneINT>{ contactsInfo: { selectedContact: null } };
        return new Action(_data, GameNames.PHONE).run(
            function phone(callback: () => void) {
                Phone.phonePromise?.(true);
                store.dispatch(setPhone(_data));
                store.dispatch(setAdvance({ canAdvance: true }));
                store.dispatch(setPhoneDisplay({ display: false, displayMessagesUI: false }));
            }
        );
    }
    static setMessage(messageObj: TtalkStateINT & { character: TCharacter; }) {
        if (messageObj.options?.wait === false) { return store.dispatch(setHistory({ type: PhoneTypes.MESSAGE, content: messageObj })); }
        else {
            Phone.finishedHistory = true;
        }


        return new Action(messageObj, GameNames.PHONE).run(
            function phoneMessage(callback: () => void) {
                // TODO: set seen words for phone?
                store.dispatch(setPhoneMessage({ ...messageObj }));
            }
        );
    }

    static setImage(image: TimageINT & { character: TCharacter; }) {
        if (image.options?.wait === false) { return store.dispatch(setHistory({ content: { ...image }, type: PhoneTypes.IMAGE })); }
        else {
            Phone.finishedHistory = true;
        }
        return new Action({ ...image }, GameNames.PHONE).run(
            function phoneMessage(callback: () => void) {
                store.dispatch(setPhoneImage(image));
            }
        );
    }
    static setQuestion(_data: PhoneQuestionFormat) {

        let question = <TquestionINT>{ displayQuestion: true, options: _data.question.options, title: _data.question.title };
        const data = { question, text: _data.question.title.text, character: _data.character };
        // if (_data.question.title.options?.wait === false) { return store.dispatch(setHistory({ content: { question, text: _data.question.title.text, character: _data.character }, type: PhoneTypes.QUESTION })); }

        return new Action(data, GameNames.PHONE).run(
            function phoneMessage(callback: () => void) {

                Phone.finishedHistory = true;
                store.dispatch(setPhoneQuestion(data));
            }
            , false);
    }
}
